/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Relevant factors for Assumption
 */
import { ValidateUtils } from 'app/shared/utils';

export class AssumptionRelevantFactors { 
    /**
     * Indicators marked as relevant to Assumption
     */
    indicatorResourceIdentifiers?: Array<string>;

    constructor(item?: Partial<AssumptionRelevantFactors>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            indicatorResourceIdentifiers: {
                type: 'uuid',
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.indicatorResourceIdentifiers : itemOrValue;

                    if (itemOrValue?.indicatorResourceIdentifiers != null) {
                        if (itemOrValue.indicatorResourceIdentifiers === '') {
                            itemOrValue.indicatorResourceIdentifiers = undefined;
                        } else if (['int32', 'int64'].indexOf('uuid') >= 0) {
                            itemOrValue.indicatorResourceIdentifiers = parseInt(itemOrValue.indicatorResourceIdentifiers.toString(), 10);
                        } else if (['float'].indexOf('uuid') >= 0) {
                            itemOrValue.indicatorResourceIdentifiers = parseFloat(itemOrValue.indicatorResourceIdentifiers.toString());
                        }
                    }
                    result = result && ValidateUtils.isValidType(value, 'uuid');
                    if (['uuid'].indexOf('uuid') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: AssumptionRelevantFactors.isValid,
        };
    }

    static isValid(obj: AssumptionRelevantFactors): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = AssumptionRelevantFactors.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.indicatorResourceIdentifiers.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

